import { render, staticRenderFns } from "./CompareResult.vue?vue&type=template&id=29199308&"
import script from "./CompareResult.vue?vue&type=script&lang=js&"
export * from "./CompareResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports